import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import ListTeamSchedules from '../components/ListTeamSchedules';
export default () => {
  return <ListTeamSchedules />
};
